import React from 'react';
import { Form } from 'react-bootstrap'

// General Bootstrap select component that builds options from properties and fires onSelectionChanged when the selected value changes.
export const SelectBox = ({
    items, // Items to render in list. If empty or not set, this component renders null.
    itemValueSelector, // Function that takes an item and returns the value to use for the "value" attriute of the option element generated for the item.
    //   If not set, the item itself is used as the value.
    itemTextSelector, // Function that takes an item and returns the text to display for the item's option element. If not set, the item itself is used.
    selectedValue, // Value of item to select initially. If not set, the first item in the list is selected.
    onSelectionChanged // Fired when selected value changes. Provides the "value" attribute of the selected option element.
}) => {
    if (!items || !items.length) {
        return null;
    }

    let optionItems = items.map((item) => {
        const value = itemValueSelector ? itemValueSelector(item) : item;
        const text = itemTextSelector ? itemTextSelector(item) : item;
        return (<option key={value} value={value}>
            {text}
        </option>);
    });
    const selectedValueText = selectedValue || optionItems[0].value;
    return (
        <Form.Control
            as="select"
            value={selectedValueText}
            onChange={(event) =>
                onSelectionChanged && onSelectionChanged(event.target.value)}
        >
            {optionItems}
        </Form.Control>
    )
}